import type { ReactNode } from 'react';
import { usePermissions } from './use-permissions';

/** Renderiza children solo si el usuario tiene el permiso (UX; backend enforce). */
export function Can({ perm, children }: { perm: string; children: ReactNode }): JSX.Element | null {
  const { can } = usePermissions();
  return can(perm) ? <>{children}</> : null;
}
